/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";

import BreadCrumbs from "./BreadCrumbs";

const propTypes = {
  breadCrumbs: PropTypes.array
};

const defaultProps = {
  breadCrumbs: []
};

const BreadCrumbsContainer = ({
  breadCrumbs
}) => {
  return (
    <BreadCrumbs
      breadCrumbs={breadCrumbs}
    />
  );
};

BreadCrumbsContainer.propTypes = propTypes;
BreadCrumbsContainer.defaultProps = defaultProps;

export default BreadCrumbsContainer;
